import React from "react";
import "./Urgency.scss";
import { getIcon } from "../../utils/images";

const Urgency = ({shipment, updates}) => {
  const urgentCounts = updates?.filter((u) => u.shipment_id === shipment?.id && u.attention) || [];
  
  if(!urgentCounts.length) return <></>

  return (
    <div className="Urgency">
      <div>
        {urgentCounts.length}
      </div>
      <img src={getIcon('arrow')} />
    </div>
  )
};

export default Urgency;